/** Preview-only discounted amount in cents. Stripe applies the real discount at
 *  invoice time; this just mirrors a percent- or amount-off coupon for display. */
export function discountedCents(
  baseCents: number,
  discount: { percentOff?: number; amountOffCents?: number } | null | undefined,
): number {
  if (!discount) return baseCents;
  if (discount.percentOff != null) {
    return Math.round((baseCents * (100 - discount.percentOff)) / 100);
  }
  if (discount.amountOffCents != null) {
    return Math.max(0, baseCents - discount.amountOffCents);
  }
  return baseCents;
}
